import {resetDriverPassword} from "../../../actions/driverAppApprovalActions";
import {Button, Grid} from "@material-ui/core";
import UniDialog from '../../Common/UniDialog';
import {TextValidator, ValidatorForm} from 'react-material-ui-form-validator';
import {operationLog} from '../../../actions/commonAction';
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {showAlertSnackbar} from "../../../reducers/uiSlice";
import {getUserPreference} from "../../../utilities/common";
import {useToken} from "../../../utilities/hooks";
import _ from 'lodash';
import Validation, {FormValidation} from "../../../utilities/formValidation";

function ResetPasswordDialog(props) {
    const {t} = useTranslation('driverApproval');
    const dispatch = useDispatch();
    const userPref = getUserPreference();
    const [resetPassWord, setResetPassWord] = useState('');
    const resetPasswordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).+$/;

    const handleResetPassWordInput = (event) => {
        setResetPassWord(event.target.value);
    }
    const handleResetPasswordSubmit = () => {
        if (!resetPasswordRegex.test(resetPassWord)) {
            dispatch(showAlertSnackbar({message: t('reset_password_format'), type: 'error'}))
            return;
        } else {
            dispatch(resetDriverPassword(props.mobile, resetPassWord, userPref.username, userPref.userCity))
                .then((res) => {
                    dispatch(operationLog('', userPref.username, '', 6, `RESET_PHONE_NUM:${props.mobile}`))
                    dispatch(showAlertSnackbar({
                        message: 'phone: ' + props.mobile + ', ' + res.biz_message,
                        type: 'success'
                    }))
                    setResetPassWord('')
                    props.handleResetpasswordDialogClose()
                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: "Reset Password failed", type: 'error'}))
                })
        }
    }

    return (
        <UniDialog
            title={t('reset_password')}
            fullWidth
            maxWidth='sm'
            disableDefaultButtons
            open={props.open}
            onClose={() => {
                props.handleResetpasswordDialogClose()
                setResetPassWord('')
            }}
        >
            <ValidatorForm>
                <Grid container spacing={4}>
                    <Grid
                        container
                        spacing={2}
                        item
                        xs={12}
                    >
                        <Grid item xs={12} container alignItems="center" justify="center">
                            <Grid item xs={3}>
                                {t('new_password')}
                            </Grid>
                            <Grid item xs={1}></Grid>
                            <Grid item xs={8}>
                                <TextValidator
                                    variant="outlined"
                                    size="small"
                                    placeholder={t('new_password')}
                                    value={resetPassWord}
                                    onChange={handleResetPassWordInput}
                                    validators={['required', 'minStringLength:8']}
                                    errorMessages={['this field is required', 'min length is 8']}
                                    fullWidth
                                    id='resetpassword-newpassword-textvalidator'
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </ValidatorForm>
            <Grid container style={{marginTop: 60, marginBottom: 10}}>
                <Grid item xs={1}>
                </Grid>
                <Grid item xs={3}>
                    <Button
                        variant='contained'
                        color="primary"
                        onClick={() => {
                            props.handleResetpasswordDialogClose()
                            setResetPassWord('')
                        }}
                    >
                        {t('cancel')}
                    </Button>
                </Grid>
                <Grid item xs={5}>
                </Grid>
                <Grid item xs={3}>
                    <Button
                        variant='contained'
                        color="secondary"
                        onClick={() => {
                            handleResetPasswordSubmit()
                        }}
                    >
                        {t('reset')}
                    </Button>
                </Grid>
            </Grid>
        </UniDialog>
    );
}

export default ResetPasswordDialog;